import { v4 as uuidv4 } from 'uuid';

import { DomainModelHelper, EntityBase } from '@digital-platform/shared/domain';
import { Signature } from '../interfaces';

export class SignatureModel extends EntityBase implements Signature {
  constructor(config?: Signature) {
    super(config);

    if (config.id) {
      this.id = DomainModelHelper.ensureDataIsString(config.id);
    } else {
      // this is only ever stored embedded in other data right now
      // therefore we can safely generate our own ids
      this.id = uuidv4();
    }

    this.role = config
      ? DomainModelHelper.ensureDataIsString(config.role)
      : SignatureModel.DEFAULT_CONFIG.role;
    this.email = config
      ? DomainModelHelper.ensureDataIsString(config.email)
      : SignatureModel.DEFAULT_CONFIG.email;
    this.name = config
      ? DomainModelHelper.ensureDataIsString(config.name)
      : SignatureModel.DEFAULT_CONFIG.name;
    this.title = config
      ? DomainModelHelper.ensureDataIsString(config.title)
      : SignatureModel.DEFAULT_CONFIG.title;
    this.company = config
      ? DomainModelHelper.ensureDataIsString(config.company)
      : SignatureModel.DEFAULT_CONFIG.company;
    this.date = config
      ? DomainModelHelper.ensureDataIsString(config.date)
      : SignatureModel.DEFAULT_CONFIG.date;
    this.isSigned = config
      ? DomainModelHelper.ensureDataIsBoolean(config.isSigned)
      : SignatureModel.DEFAULT_CONFIG.isSigned;

    if (config.inviteId) {
      this.inviteId = DomainModelHelper.ensureDataIsString(config.inviteId);
    }
    if (config.signingLink) {
      this.signingLink = DomainModelHelper.ensureDataIsString(
        config.signingLink
      );
    }
    if (config.userId) {
      this.userId = DomainModelHelper.ensureDataIsString(config.userId);
    }
    if (config.roleId) {
      this.roleId = DomainModelHelper.ensureDataIsString(config.roleId);
    }
    if (config.order) {
      this.order = DomainModelHelper.ensureDataIsNumber(config.order);
    }
    if (config.status) {
      this.status = DomainModelHelper.ensureDataIsString(config.status);
    }
  }

  public static readonly DEFAULT_CONFIG: Signature = {
    id: '',
    role: 'Signer_1',
    email: '',
    name: '',
    title: '',
    company: '',
    date: null,
    isSigned: false,
  };

  public readonly id: string;
  public readonly inviteId?: string;
  public readonly signingLink?: string;
  public readonly userId?: string;
  public readonly role: string;
  public readonly roleId?: string;
  public readonly email: string;
  public readonly name: string;
  public readonly title: string;
  public readonly company: string;
  public readonly date: string | null;
  public readonly isSigned: boolean;
  public readonly order?: number;
  public readonly status?: string;
}
